interface Props {
  children: string;
}

const Hidden = ({ children }: Props) => (
  <span className={'hidden'}>{children}</span>
);

export default Hidden;
